import * as React from "react";
import { connect } from "react-redux";
import { Link, withRouter } from "react-router-dom";
import * as queryString from 'query-string';
import * as types from "../../constants/actionTypes";
import { Collapse, Button, CardBody, Card } from 'reactstrap';
import StarRatings from 'react-star-ratings';
import DataComponent from "../common/DataComponent";
import LocationDetailsMap from './LocationDetailsMap';
import Spinner from "../common/spinner";
import Select from "../common/input/select";
import FavoritedLabel from "../favproviders/FavoritedLabel";
import { formatPhoneNumber } from "../../helpers/formatting";
import Rating, { RatingCount, Stars } from '../common/Rating';

import { getDirectionsUrl } from "../../helpers/location";
import * as Tools from "../../helpers/Tools";
import { logUI } from "../../api/andyliticsApi";
import StaticHtmlContent from "../common/staticHtmlContent";
import SectionLoadingError from "../common/SectionLoadingError";

class Details extends DataComponent {

    constructor(props) {
        super(props);
        this.toggleInsurance = this.toggleInsurance.bind(this);
        this.toggleIndustry = this.toggleIndustry.bind(this);
        this.selectAddress = this.selectAddress.bind(this);
        this.onMapClicked = this.onMapClicked.bind(this);
        this.sortCommentsBy = this.sortCommentsBy.bind(this);
        this.getDirections = this.getDirections.bind(this);

        this.getLocation = this.getLocation.bind(this);
        this.getLocationCallback = this.getLocationCallback.bind(this);

        this.state = {
            collapseInsurance: false,
            collapseIndustry: false,
            locations: [],
            selectedLocation: null,
            sortComments: "Date",
            mapCenter: null,
            userLocation: "",
            selectedLocIndex: 0
        };

        // this.getLocation(); //commenting this as this is unused and unnecessarily asking for accessing user location.
    }

    componentDidMount() {
        const { careGapsSessionId } = this.props;
        if (super.componentDidMount) { super.componentDidMount(); }
        logUI("MBHWeb.UI.Details.ComponentDidMount", new Date(), Tools.getURLPath(), careGapsSessionId && {careGapsSessionId : careGapsSessionId });
    }

    shouldLoadData() {
        const searchModel = this.getSearchModel();
        return searchModel.ids !== null;
    }

    getSearchModel() {
        const { match, location } = this.props;
        let providerId = match.params.npi;
        let providerIdType = 'NPI';
        if (!providerId) {
            const searchParams = location.search ? queryString.parse(location.search) : location.searchParms && queryString.parse(location.searchParms);
            providerId = searchParams && searchParams.epicId;
            providerIdType = 'EpicID';
        }
        return { ids: providerId, idType: providerIdType };
    }

    loadData() {
        const { networkCode, hasHealthPlanLogin, hasFirstCare } = this.props;
        let searchModel = this.getSearchModel();
        if (networkCode && networkCode != null && (hasHealthPlanLogin || hasFirstCare)) {
            searchModel.networkCode = networkCode;
        }
        this.props.getProviderDetails(searchModel);
        //this.props.getGeoLocation();
    }

    componentDidUpdate(prevProps, prevState, snapshot) {
        if (super.componentDidUpdate) { super.componentDidUpdate(prevProps, prevState, snapshot); }
        const { providerDetails, earliestSchedule } = this.props;
        const { selectedLocation } = this.state;
        const provider = providerDetails && providerDetails.length > 0 ? providerDetails[0] : null;
        const requiredLocation = selectedLocation ? selectedLocation : provider && provider.locations && provider.locations.length > 0 ? provider.locations[0] : null;

        if (provider && !earliestSchedule) {
            if (requiredLocation && requiredLocation.openSchedules && requiredLocation.openSchedules.dateAndTimes && requiredLocation.openSchedules.dateAndTimes.length > 0 && requiredLocation.openSchedules.dateAndTimes[0].times && requiredLocation.openSchedules.dateAndTimes[0].times.length > 0) {
                let dt = requiredLocation.openSchedules.dateAndTimes[0].times[0];
                const visitType = window.serverData.data.defaultVisitTypeName;      // New Patient visit type is configurable by environment

                // filter for New Patient, if present...
                let ids = requiredLocation.openSchedules.dateAndTimes.map(d => {
                    let types = d.times.filter(t => t.visitTypeDisplayName.indexOf(visitType) >= 0);
                    return types;
                }).filter(id => id.length > 0);

                for (var i = 0; i < ids.length; i++) {
                    let thisIsSoStupid = ids[i];
                    for (var j = 0; j < thisIsSoStupid.length; j++) {
                        let sigh = thisIsSoStupid[j];
                        if (sigh) {
                            dt = sigh;
                        }
                    }
                }

                let searchModel = {
                    providerId: provider.npi,
                    providerIdType: "NPI",
                    scheduleType: "OpenSchedule",
                    visitTypeId: dt.visitTypeId,
                    departmentId: dt.departmentId
                };

                this.props.getEarliestSchedule(searchModel);
            }
        }
    }

    componentWillUnmount() {
        const { clearProviderDetail } = this.props;
        clearProviderDetail();
    }

    toggleInsurance() {
        this.setState({ collapseInsurance: !this.state.collapseInsurance });
    }

    toggleIndustry() {
        this.setState({ collapseIndustry: !this.state.collapseIndustry });
    }

    selectAddress(index) {
        if (this.props.providerDetails[0].locations && index >= 0 && index < this.props.providerDetails[0].locations.length) {
            this.setState({
                selectedLocIndex: index,
                selectedLocation: this.props.providerDetails[0].locations[index],
                mapCenter: { lat: this.props.providerDetails[0].locations[index].coordinates.lat, lng: this.props.providerDetails[0].locations[index].coordinates.lon }
            });
        }
    }

    sortCommentsBy(sort) {
        if (sort !== "") {
            this.setState({ sortComments: sort });
        }
    }

    onMapClicked() {
    }

    getDirections(loc) {
        const baseUrl = "https://www.google.com/maps/dir/";
        const url = `${baseUrl}Current+Location/${loc.locationStreet1},${loc.locationCity}, TX ${loc.locationZip}`;
        window.open(url, "_blank");
    }

    getLocation() {
        if (navigator.geolocation) {
            navigator.geolocation.getCurrentPosition(this.getLocationCallback);
        }
        else {
            console.log("unable to get geo location");
        }
    }

    getLocationCallback(position) {
        this.setState({ userLocation: `${position.coords.latitude},${position.coords.longitude}` });
    }

    render() {
        const { providerDetails, userLatitude, userLongitude, onlineSchedulingEnabled } = this.props;
        const prov = (providerDetails) ? providerDetails[0] : "";
        const { addProviderToFavorites } = this.props;

        let locationOptions = [];
        let selectedLoc = null;

        let mapCenter = { lat: 0, lng: 0 };
        const userLocation = userLatitude ? `${userLatitude},${userLongitude}` : "";

        if (prov && prov.locations && prov.locations.length > 0) {
            prov.locations.sort(function (locationA, locationB) {
                const isPrimaryA = locationA.isPrimary.toLowerCase();
                const isPrimaryB = locationB.isPrimary.toLowerCase();
                if (isPrimaryA === "true")
                    return -1;
                if (isPrimaryB === "true")
                    return 1;
                else return 0;
            });
            selectedLoc = this.state.selectedLocation ? this.state.selectedLocation : prov.locations[0];
            mapCenter = this.state.mapCenter ? this.state.mapCenter : { lat: selectedLoc.coordinates.lat, lng: selectedLoc.coordinates.lon };

            locationOptions = prov.locations.map((loc, i) => {
                return <option key={i} value={i}>
                    {`${loc.locationStreet1} ${loc.locationStreet2 ? loc.locationStreet2 : ""} ${loc.locationCity}, ${loc.locationState ? loc.locationState : "TX"} ${loc.locationZip}`}
                </option>;
            });
        }

        let specialties = [];
        if (prov && prov.specialties) {
            specialties = prov.specialties.map((spec, i) => { return spec.Specialty; });
        }

        let phone = "---";
        let phoneHref = "";

        if (prov && prov.consumerCallCenterNumber) {
            phone = prov.consumerCallCenterNumber;
            phoneHref = "tel:" + prov.consumerCallCenterNumber;
        }
        else if (prov && prov.locations && prov.locations.length > 0) {
            phone = formatPhoneNumber(prov.locations[0].locationPhone);
            phoneHref = "tel:" + prov.locations[0].locationPhone;
        }

        let languages = [];
        let ageGroupsSeen = [];
        let hospitals = [];
        let insurance = [];
        let education = [];
        let certifications = [];
        let reviews = [];
        let reviewCount = 0;
        let reviewCategoryCount = 0;
        let ratingCount = 0;
        let averageRating = 0;

        let comments = [];
        let compliance = [];

        let showVendor = true;
        let showDesc = true;

        let nonParticipating = false;
        let participatingWithDisclosure = false;
        let participatingWithoutDisclosure = false;
        let effectiveDate = "";
        let qaIndependent = [];

        if (prov && prov.practiceGroups && prov.practiceGroups.length > 0) {
            qaIndependent = prov.practiceGroups.filter(group => group.name === 'QA Independent');
        }

        let sortOptions = [{ value: 'Date', label: 'Date' },
        { value: 'Rating', label: 'Rating' }];

        if (prov && prov.languages) {
            languages = prov.languages.map((l, i) => { return l.language; });
        }

        if (prov && prov.ageGroupsSeen) {
            ageGroupsSeen = prov.ageGroupsSeen.map((a, i) => { return a.name; });
        }

        if (prov && prov.hospitalAffiliations) {
            hospitals = prov.hospitalAffiliations.map((h, i) => {
                return <div key={i}>{h.name}</div>;
            });
        }

        if (prov && prov.insuranceV2) {
            insurance = prov.insuranceV2.map((ins, i) => {
                return (
                    <div className="insurance-plan-row" key={i}>
                        <div className="row">
                            <div className={"col-8" + prov.isReferable ? " col-8" : ""}>
                                <div className="insurance-plan-row__name">{ins.fullName}</div>
                            </div>
                            {prov.isReferable &&
                                <div className="col-4">
                                    <div className="insurance-plan-row__new">
                                        {ins.acceptingPatients && <span className="icon-check" />}
                                        {ins.acceptingPatients && <div className="mobile-label">Accepts New Patients</div>}
                                        {ins.acceptingPatients === false && <span className="icon-hyphen" />}
                                    </div>
                                </div>
                            }
                        </div>
                    </div>
                );
            });
        }

        if (prov && prov.training) {
            education = prov.training.map((train, i) => {
                return <li key={i}>{train.educationDescription ? `${train.educationDescription}: ` : ""}{train.educationFieldOfStudy ? `${train.educationFieldOfStudy}, ` : ""}{train.educationInstitution ? train.educationInstitution : ""}{train.educationGraduationyear ? ` (${train.educationGraduationyear})` : ""}</li>;
            });
        }

        if (prov && prov.boardCertifications) {
            certifications = prov.boardCertifications.map((cert, i) => {
                return <li key={i}> {cert.boardCertificationSpecialty ? `${cert.boardCertificationSpecialty} - ` : ""}{cert.boardCertificationName ? cert.boardCertificationName : ""}{cert.boardCertificationYear ? ` (${cert.boardCertificationYear})` : ""}</li>;
            });
        }

        if (prov && prov.reviewRatings && prov.reviewRatings.aggregateRatings) {

            reviewCount = prov.reviewRatings.aggregateRatings.reviewCount;
            reviewCategoryCount = prov.reviewRatings.aggregateRatings.subRatings.length;
            ratingCount = prov.reviewRatings.aggregateRatings.ratingCount;
            averageRating = prov.reviewRatings.aggregateRatings.averageRating;

            reviews = prov.reviewRatings.aggregateRatings.subRatings.map((review, i) => {
                return (
                    <div className="provider-review" key={i}>
                        <span className="blue-text-label">{review.metric}</span>
                        <div className="fr-star-rating star-rating">
                            <div className="star">
                                <StarRatings
                                    rating={review.averageRating}
                                    starRatedColor={"#FFB71B"}
                                    numberOfStars={5}
                                    name="rating"
                                    starDimension="15px"
                                    starSpacing="2px"
                                />
                            </div>
                        </div>
                    </div>
                );
            });
        }

        if (prov && prov.reviewRatings && prov.reviewRatings.reviews) {
            const sorted = prov.reviewRatings.reviews.sort((a, b) => {
                if (this.state.sortComments === "Date") {
                    return new Date(b.reviewDate) - new Date(a.reviewDate);
                }
                else if (this.state.sortComments === "Rating") {
                    return b.rating - a.rating;
                }
            });

            comments = sorted.map((review, i) => {
                return (
                    <div className="provider-list-item" key={i}>
                        <div className="row">
                            <div className="col-12 rating-comments">
                                <div className="review-info">
                                    <div className="provider-rating">
                                        <div className="rating-container">
                                            <div className="star-rating">
                                                <div className="star">
                                                    <StarRatings
                                                        rating={review.rating}
                                                        starRatedColor={"#FFB71B"}
                                                        numberOfStars={5}
                                                        name="rating"
                                                        starDimension="15px"
                                                        starSpacing="2px"
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <span className="blue-text-label">{new Date(review.reviewDate).toLocaleDateString("en-US", { year: 'numeric', month: 'short', day: 'numeric' })}</span>
                                </div>
                                <span className="patient-review">{review.bodyText}</span>
                            </div>
                        </div>
                    </div>
                );
            });
        }

        if (prov && prov.compliance) {
            showVendor = false;
            showDesc = false;
            for (var i = 0; i < prov.compliance.length; i++) {
                let c = prov.compliance[i];
                if (c.vendor !== "") showVendor = true;
                if (c.paymentType !== "") showDesc = true;
            }

            compliance = prov.compliance.map((c, i) => {
                return (
                    <div className="insurance-plan-row" key={i}>
                        <div className="row">
                            {showVendor &&
                                <div className="col-12 col-sm-4">
                                    <div className="insurance-plan-row__name"><div className="mobile-element">Vendor: </div>{c.vendor}</div>
                                </div>
                            }
                            {showDesc &&
                                <div className="col-12 col-sm-8">
                                    <div className="insurance-plan-row__name"><div className="mobile-element">Description: </div>{c.paymentType}</div>
                                </div>
                            }
                        </div>
                    </div>
                );
            });
        }

        // decide which set of compliance text to display:
        if (prov && (!prov.compliance || prov.compliance.length === 0)) {
            nonParticipating = true;
            participatingWithDisclosure = false;
            participatingWithoutDisclosure = false;
        }
        else if (prov && prov.compliance.length > 0) {
            nonParticipating = false;
            let part = false;
            for (var i = 0; i < prov.compliance.length; i++) {
                if (prov.compliance[i].approved.trim() === "Y") {
                    part = true;
                    break;
                }
            }
            if (part) {
                participatingWithDisclosure = true;
                participatingWithoutDisclosure = false;
            }
            else {
                participatingWithDisclosure = false;
                participatingWithoutDisclosure = true;
                effectiveDate = prov.compliance[0].effectiveDate;
            }
        }

        // build the schedule online link
        let scheduleUrl = "";

        if (prov) {
            if (this.props.earliestSchedule) {
                const sch = this.props.earliestSchedule;
                if (sch.scheduleDays && sch.scheduleDays.length > 0) {
                    const dept = sch.scheduleDays[0].department;
                    const visit = sch.scheduleDays[0].visitType;
                    const date = sch.scheduleDays[0].date;
                    const time = sch.scheduleDays[0].slots[0].time;

                    //scheduleUrl = `/schedule/${prov.npi}/${visit.id}/${dept.id}/${date}/${time}`;
                    scheduleUrl = `/schedule/${prov.npi}/OpenSchedule/${visit.id}/${dept.id}`;
                }
            }
            else if (selectedLoc && selectedLoc.openSchedules && selectedLoc.openSchedules.dateAndTimes && selectedLoc.openSchedules.dateAndTimes.length > 0 && selectedLoc.openSchedules.dateAndTimes[0].times && selectedLoc.openSchedules.dateAndTimes[0].times.length > 0) {
                scheduleUrl = `/schedule/${prov.npi}/OpenSchedule/${selectedLoc.openSchedules.dateAndTimes[0].times[0].visitTypeId}/${selectedLoc.openSchedules.dateAndTimes[0].times[0].departmentId}`;
            }
            else {
                scheduleUrl = `/schedule/${prov.npi}`;
            }
        }

        return (
            <div className={`container-fluid body-content ${prov ? "provider-details-container" : ""}`}>
                    {!providerDetails ?
                        <div className="row">
                            <div className="col-12 maxWidth-content">
                                <SectionLoadingError message="We're sorry, we could not find this doctor." />
                            </div>
                        </div>
                    : prov &&
                    <React.Fragment>
                        {
                            this.props.searchRunning &&
                            <Spinner />
                        }
                        <div className="row">
                            <div className="col-12">
                                <div className="row section-padding" id="provider-detail-intro">
                                    <div className="banner-bg"><div className="banner-bg__left" /></div>
                                    <div className="col-12 maxWidth-content">
                                        <div className="row intro-content">
                                            <div className="col-12">
                                                <div className="dr-img-container">
                                                    <div className="dr-img" style={{ backgroundImage: `url(${prov.photo})` }} />
                                                </div>
                                                <div className="provider-info-container">
                                                    <div className="row">
                                                        <div className="col-12">
                                                            <div className="row">
                                                                <div className="col-12 col-sm-10">
                                                                    <div className="section-heading heading-btm-margin">
                                                                        <div className="heading-content">{prov.displayName}</div>
                                                                    </div>
                                                                </div>
                                                                <div className="col-12 col-sm-2 text-right">{/* Hiding for now since they aren't required for launch --- */}
                                                                    {/*<div className="d-none d-lg-block provider-contact">
                                                                <a href="#"> SHARE </a> | <a href="#"> PRINT </a>
                                                            </div>*/}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 col-xl-7">
                                                                    <div className="section-subtitle">{specialties.join(", ")}</div>
                                                                    {prov.reviewRatings &&
                                                                        <Rating align="right" isRatingCount isAverageRatingCount reviewCount={ratingCount} starDimension="15px" averageRating={prov.reviewRatings.aggregateRatings.averageRating} containerClass="intro-rating">
                                                                            <Stars />
                                                                            <RatingCount />
                                                                        </Rating>}
                                                                </div>
                                                                <div className="col-12 col-xl-5 text-xl-right">
                                                                    <FavoritedLabel NPI={prov.npi} />
                                                                    {prov && prov.isReferable ?
                                                                        <div>
                                                                            {prov.isOpenSchedulingAvailable && onlineSchedulingEnabled ?
                                                                                <Link to={{ pathname: scheduleUrl }} className={"btn btn-primary " + (selectedLoc && selectedLoc.openSchedules ? "" : " disabled ")}
                                                                                    onClick={() => logUI("MBHWeb.UI.ProviderDetails.OpenScheduleLinkClicked", new Date(), Tools.getURLPath())}
                                                                                >SCHEDULE AN APPOINTMENT</Link> :
                                                                                <div className="call-appt-container">
                                                                                    {phone && phone !== "---" && 
                                                                                        <a href={"tel:" + phone} className="phone-link">
                                                                                            <div className="call-appt-text">Call to schedule</div>
                                                                                        </a>
                                                                                    }
                                                                                </div>
                                                                            }
                                                                        </div> :
                                                                        <div className="no-appt-container">
                                                                            <div className="no-appt-text">Not available for appointments</div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                <div className="col-12 col-md-6 provider-phone">
                                                                    {phone ?
                                                                        <a className="phone-link" href={phoneHref}>
                                                                            <div className="details-icon-prepend">
                                                                                <div className="icon-col"><span className="icon-phone" /></div>
                                                                                <div className="details-col">
                                                                                    {phone}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                        : <div className="details-icon-prepend">
                                                                            <div className="icon-col"><span className="icon-phone" /></div>
                                                                            <div className="details-col">
                                                                                <div className="no-data-dash">
                                                                                    <div />
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                                <div className="col-12 col-xl-6 schedule-cta">

                                                                    {
                                                                        prov.acceptingNewPatients && prov.isReferable &&
                                                                        <div className="flag-new-pat"><span className="icon-accepts" /> <div className="flag-new-pat__label">Accepts New Patients</div></div>
                                                                    }
                                                                    {
                                                                        prov.usesMyBSWHealth &&
                                                                        <div className="flag-mybswh"><img alt="MyBSWHealth" src="/images/mybswh-portal.png" /> <div className="flag-mybswh__label">portal</div><a href="#" data-toggle="tooltip" title="This provider allows you to use MyBSWHealth which is a mobile app and web portal where you can: manage appointments, message your doctor, view visit summary, test results, pay bills, and much more!">
                                                                            <span className="icon-question" /></a>
                                                                        </div>
                                                                    }

                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12 col-xl-6 item-tier">
                                                                    {prov.tierCoverage &&
                                                                        <div className="details-icon-prepend">
                                                                            <div className="icon-col">
                                                                                {prov.tierCoverage === '1' && '$'}
                                                                                {prov.tierCoverage === '2' && '$$'}
                                                                            </div>
                                                                            <div className="details-col">
                                                                                Tier {prov.tierCoverage} SWHP In-Network
                                                                            </div>
                                                                        </div>
                                                                    }
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>


                                            </div>
                                        </div>
                                    </div>
                                </div>

                                {/* LOCATION SECTION */}
                                <div className="row section-padding" id="provider-detail-location">
                                    <div className="col-12 maxWidth-content">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="location-info">
                                                    <div className="row">
                                                        <div className="form col-12">
                                                            {locationOptions && locationOptions.length > 1
                                                                ? <div>
                                                                    <div className="section-heading heading-btm-margin">Locations</div>
                                                                    <Select name="providerLocation" placeholder="Select Another Location"
                                                                        value={this.state.selectedLocIndex} renderedOptions={locationOptions}
                                                                        disableEmptyOption onChange={(e) => this.selectAddress(e.target.value)}
                                                                    />
                                                                </div>
                                                                : <div className="section-heading heading-btm-margin">Location</div>
                                                            }
                                                            {selectedLoc ?
                                                                <div className="provider-location-description">

                                                                    <div className="provider-address">
                                                                        <a className="directions-link" onClick={() => { this.getDirections(selectedLoc); }} target="_blank">
                                                                            <div className="details-icon-prepend">
                                                                                <div className="icon-col">
                                                                                    <span className="icon-address" />
                                                                                </div>
                                                                                <div className="details-col">
                                                                                    <span>
                                                                                        {selectedLoc.locationName &&            // some locations don't have names
                                                                                            <span>
                                                                                                {selectedLoc.locationName}
                                                                                                <br />
                                                                                            </span>
                                                                                        }
                                                                                        {selectedLoc.locationStreet1}
                                                                                        <br />
                                                                                        {selectedLoc.locationCity}, {selectedLoc.locationState ? selectedLoc.locationState : "TX"} {selectedLoc.locationZip}
                                                                                    </span>

                                                                                    {
                                                                                        !selectedLoc &&
                                                                                        <span>---</span>/* If there is no info to show, show three dashes --- */
                                                                                    }
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>

                                                                    <div className="provider-phone">
                                                                        <a className={(selectedLoc.locationPhone) ? "phone-link" : "no-link"} href={(selectedLoc.locationPhone) ? "tel:" + (formatPhoneNumber(selectedLoc.locationPhone)) : "#"}>
                                                                            <div className="details-icon-prepend">
                                                                                <div className="icon-col">
                                                                                    <span className="icon-phone" />
                                                                                </div>
                                                                                <div className="details-col">
                                                                                    {(selectedLoc.locationPhone) ?
                                                                                        <div>{formatPhoneNumber(selectedLoc.locationPhone)}</div>
                                                                                        : <div className="no-data-dash">
                                                                                            <div />
                                                                                        </div>}
                                                                                </div>
                                                                            </div>
                                                                        </a>
                                                                    </div>
                                                                </div>
                                                                :
                                                                <div className="provider-location-description no-locations">
                                                                    No locations are available for this doctor.
                                                                </div>
                                                            }
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    {selectedLoc &&
                                        <div className="location-map-bg">
                                            <LocationDetailsMap
                                                    selectedLoc={selectedLoc}
                                                    mapCenter={mapCenter}
                                                    getDirections={this.getDirections}
                                                    onMapClicked={this.onMapClicked}
                                            />
                                        </div>
                                    }
                                </div>
                                {/* ABOUT SECTION */}
                                <div className="row section-padding" id="provider-detail-about">
                                    <div className="col-12 maxWidth-content">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="section-heading heading-btm-margin">About</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            <div className="col-12">
                                                {(prov && prov.biography && prov.biography.length > 0) && <span><StaticHtmlContent content={prov.biography} /></span>}
                                                {/* This is the default about message for providers who have not entered a description */}
                                                {(!prov || !prov.biography || prov.biography.length === 0) && <span>Serving all people by providing personalized health and wellness through exemplary care, education and research.</span>}
                                                <br /><br />
                                            </div>
                                        </div>
                                        <div className="row">
                                            {
                                                (languages && languages.length > 0) &&
                                                <div className="col-12 col-sm-3">
                                                    <div>
                                                        <h3>Languages Spoken</h3>
                                                        <span>{languages.join(", ")}</span>
                                                    </div>
                                                </div>
                                            }
                                            {
                                                (ageGroupsSeen && ageGroupsSeen.length > 0) &&
                                                <div className="col-12 col-sm-5">
                                                    <div>
                                                        <h3>Age Groups Seen</h3>
                                                        <span>{ageGroupsSeen.join(", ")}</span>
                                                    </div>
                                                </div>
                                            }
                                            <div className="col-12 col-sm-3">
                                                {
                                                    (hospitals && hospitals.length > 0) &&
                                                    <div>
                                                        <h3>Hospital Affiliations</h3>
                                                        {hospitals}
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {
                                            (insurance && insurance.length > 0) &&
                                            <div className="row">{/* If there is no insurance info to show, hide this row */}
                                                <div className="col-12">
                                                    <div className="insurance-accepted">
                                                        <h3 onClick={this.toggleInsurance}>Insurance Accepted {this.state.collapseInsurance ? <span className="icon-dd-up" /> : <span className="icon-dd" />}</h3>
                                                        <Collapse isOpen={this.state.collapseInsurance}>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="insurance-msg">*Accepted plans and benefits may vary by location.</div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="insurance-heading-row">
                                                                        <div className="row">
                                                                            <div className="col-8">
                                                                                <div className="insurance-heading-row__item">INSURANCE PLAN</div>
                                                                            </div>
                                                                            {prov && prov.isReferable &&
                                                                                <div className="col-4">
                                                                                    <div className="insurance-heading-row__item--accepts">ACCEPTS NEW PATIENTS</div>
                                                                                </div>
                                                                            }
                                                                        </div>
                                                                    </div>
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    {insurance}
                                                                </div>
                                                            </div>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="insurance-disclaimer ng-scope">Insurance listings are subject to change without prior notice. Please call the physician's office or health plan to verify coverage information prior to scheduling your visit or procedure. PPO Network Agreements include participating Employers and/or Administrator only. Not all members participating in contracted networks have in network access. Networks include Beech Street, HealthSmart, PHCS and texas True Choice. In network participation is updated on a monthly basis by the network.{qaIndependent.length > 0 ? " Baylor Scott & White Health does not manage the insurances accepted for this doctor. Please contact the office directly to confirm coverage." : ""}</div>
                                                                </div>
                                                            </div>
                                                        </Collapse>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>

                                {/* BACKGROUND SECTION */}
                                <div className="row section-padding" id="provider-detail-background">
                                    <div className="section-divider">
                                        <div className="section-divider__left" />
                                        <div className="section-divider__center" />
                                        <div className="section-divider__right" />
                                    </div>
                                    <div className="col-12 maxWidth-content">
                                        <div className="row">
                                            <div className="col-12">
                                                <div className="section-heading heading-btm-margin">Background</div>
                                            </div>
                                        </div>
                                        <div className="row">
                                            {
                                                (education && education.length > 0) &&
                                                <div className="col-12 col-sm-7"> {/* Hide this Div if there is no Education info to display */}

                                                    <div>
                                                        <h3>Education</h3>
                                                        <ul>
                                                            {education}
                                                        </ul>
                                                    </div>

                                                </div>
                                            }
                                            <div className="col-12 col-sm-5">
                                                {
                                                    (certifications && certifications.length > 0) &&
                                                    <div>
                                                        <h3>Certifications</h3>
                                                        <ul>
                                                            {certifications}
                                                        </ul>
                                                    </div>
                                                }
                                            </div>
                                        </div>
                                        {
                                            compliance && compliance.length > 0 &&
                                            <div className="row">{/* If there are no industry relationships, hide this row */}
                                                <div className="col-12">
                                                    <div className="industry-rel">
                                                        <h3 onClick={this.toggleIndustry}>Industry Relationships {this.state.collapseIndustry ? <span className="icon-dd-up" /> : <span className="icon-dd" />}</h3>
                                                        <Collapse isOpen={this.state.collapseIndustry}>
                                                            <div className="row">
                                                                <div className="col-12">
                                                                    <div className="industry-rel__description">
                                                                        {
                                                                            nonParticipating &&
                                                                            <p><small>Physicians who are not employed, contracted with administrative duties or performing research with Baylor Scott & White Health are not required to report relationships and activities with industry partners such as pharmaceutical, biotech, or medical device companies(collectively referred to as Industry). Information regarding these relationships is therefore not available on this page.However, patients may visit CMS’ Open Payments Database for more information, and should feel free to speak with their physician about relationships with Industry.</small></p>
                                                                        }
                                                                        {
                                                                            participatingWithDisclosure &&
                                                                            <div>
                                                                                <p><small>Baylor Scott & White Health’s vision is to be the most trusted name in giving and receiving safe, quality, compassionate healthcare.As part of that vision, Baylor Scott &White Health is committed to dealing honestly, fairly and with integrity in all matters to provide exemplary patient care, broaden medical knowledge, train the next generation of physicians and support outside relationships that promise public benefit.To that end, Baylor Scott & White Health physicians may collaborate with health care industry partners such as pharmaceutical, biotech, or medical device companies(collectively referred to as Industry) to help develop medical breakthroughs, or provide medical expertise or education.To promote professional and commercial integrity in such matters, physicians who are employed, contracted for administrative duties or performing research with Baylor Scott & White Health seek advanced approval for certain new Industry relationships, and report their Industry relationships and activities to the Office of Corporate Compliance annually for review.</small></p>
                                                                                <p><small>Baylor Scott & White Health publicly discloses reported payments to these physicians and their immediate family members of $5,000 or more from Industry companies with which the physicians interact as part of their professional activities.The information on this website may differ somewhat from information on other publicly available databases due to different reporting periods, definitions, or reporting requirements.Patients may visit CMS’ Open Payments Database for more information, and should feel free to speak with their physician about relationships with Industry.</small></p>
                                                                            </div>
                                                                        }
                                                                        {
                                                                            participatingWithoutDisclosure &&
                                                                            <div>
                                                                                <p><small>Baylor Scott & White Health’s vision is to be the most trusted name in giving and receiving safe, quality, compassionate healthcare. As part of that vision, Baylor Scott & White Health is committed to dealing honestly, fairly and with integrity in all matters to provide exemplary patient care, broaden medical knowledge, train the next generation of physicians and support outside relationships that promise public benefit.To that end, Baylor Scott & White Health physicians may collaborate with health care industry partners such as pharmaceutical, biotech, or medical device companies(collectively referred to as Industry) to help develop medical breakthroughs, or provide medical expertise or education.To promote professional and commercial integrity in such matters, physicians who are employed, contracted for administrative duties or performing research with Baylor Scott & White Health seek advanced approval for certain new Industry relationships, and report their Industry relationships and activities to the Office of Corporate Compliance annually for review. </small></p>
                                                                                <p><small>Baylor Scott & White Health publicly discloses reported payments to these physicians and their immediate family members of $5,000 or more from Industry companies with which the physicians interact as part of their professional activities.The information on this website may differ somewhat from information on other publicly available databases due to different reporting periods, definitions, or reporting requirements.Patients may visit CMS’ Open Payments Database for more information, and should feel free to speak with their physician about relationships with Industry.</small></p>
                                                                                <p><b>As of <span>{effectiveDate}</span>, <span>{prov.displayName}</span>&nbsp;<span id='non_coi_IndustryRelationshipNote'> has reported no outside relationship with Industry that is applicable to this listing.</span></b></p>
                                                                            </div>
                                                                        }
                                                                    </div>
                                                                </div>
                                                            </div>

                                                            <div className="row">
                                                                {
                                                                    showVendor &&
                                                                    <div className="col-12 col-sm-4 desktop-element">
                                                                        <h3>Vendor</h3>
                                                                    </div>
                                                                }
                                                                {
                                                                    showDesc &&
                                                                    <div className="col-12 col-sm-8 desktop-element">
                                                                        <h3>Description</h3>
                                                                    </div>
                                                                }
                                                            </div>

                                                            {compliance}
                                                        </Collapse>
                                                    </div>
                                                </div>
                                            </div>
                                        }
                                        {
                                            education.length === 0 && certifications.length === 0 && compliance.length === 0 &&
                                            <div className="row">
                                                <div className="col-12">
                                                    <span>No background information is available for this doctor.</span>
                                                </div>
                                            </div>
                                        }
                                    </div>
                                </div>




                                {/* REVIEWS SECTION */}
                                {ratingCount !== 0 &&
                                    <div className="row section-padding" id="provider-detail-reviews">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                <div className="col-12 col-sm-6">
                                                    <div className="section-heading heading-btm-margin">Reviews ({ratingCount})</div>
                                                </div>
                                                <div className="col-12 col-sm-6 overall-rating-container align-content-center">
                                                    <div className="blue-text-label">Overall: </div>
                                                    <Rating align="left" isRatingCount isAverageRatingCount starDimension="15px" averageRating={averageRating}>
                                                        <RatingCount />
                                                        <Stars />
                                                    </Rating>
                                                </div>
                                            </div>
                                            {reviews && reviews.length > 0 &&
                                                <div className="row">
                                                    <div className="col-12 col-xl-6">
                                                        {reviews[0]}
                                                    </div>
                                                    <div className="col-12 col-xl-6">
                                                        {reviews[2]}
                                                    </div>
                                                    <div className="col-12 col-xl-6">
                                                        {reviews[4]}
                                                    </div>
                                                    <div className="col-12 col-xl-6">
                                                        {reviews[1]}
                                                    </div>
                                                    <div className="col-12 col-xl-6">
                                                        {reviews[3]}
                                                    </div>
                                                    <div className="col-12 col-xl-6">
                                                        {reviews[5]}
                                                    </div>

                                                </div>
                                            }
                                            {comments && comments.length > 0 &&
                                                <div>
                                                    <div className="row provider-review-sort">
                                                        <div className="form col-12 col-sm-8">
                                                            <h3>Patient Comments<sup>**</sup></h3> {/* Hide if there are no patient comments */}
                                                        </div>
                                                        <div className="form col-12 col-sm-4">


                                                            <Select name="sortBy" placeholder="Sort by"
                                                                value={this.state.sortComments} options={sortOptions} disableEmptyOption
                                                                onChange={(e) => this.sortCommentsBy(e.target.value)}
                                                            />
                                                        </div>
                                                    </div>

                                                    <div id="divReviews">
                                                        <div className="row provider-review-list">
                                                            <div className="col-12">
                                                                {comments}
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            }
                                            <div className="row"> {/* The provider legal info only needs to show if there are ratings.*/}
                                                <div className="col-12">
                                                    <div className="provider-legal">
                                                        *The patient rating score is an average of all responses to physician-related questions on our nationally recognized <a target="_blank" href="https://www.bswhealth.com/physicians/about-press-ganey-satisfaction-survey">Press Ganey Satisfaction Survey</a>.
                                                {comments && comments.length > 0 &&
                                                            <span><br /><br />**Patient comments are gathered from our <a target="_blank" href="https://www.bswhealth.com/physicians/about-press-ganey-satisfaction-survey">Press Ganey Satisfaction Survey</a> and are displayed in their entirety. Patients are de-identified for confidentiality and patient privacy.</span>}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }

                                {
                                    ratingCount === 0 &&
                                    <div className="row section-padding" id="provider-detail-reviews">
                                        <div className="col-12 maxWidth-content">
                                            <div className="row">
                                                <div className="col-12">
                                                    <div className="section-heading heading-btm-margin">Reviews</div>
                                                </div>
                                            </div>
                                            <div className="row">
                                                <div className="col-12">
                                                    <span>No reviews have been submitted for this doctor.</span>
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                }
                            </div>
                            </div>
                        </React.Fragment>
                    }
                </div>

        );
    }
}

const openScheduleStart = () => {
    const dt = new Date();
    return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')} 00:00:00`;
};

const openScheduleEnd = () => {
    const dt = new Date();
    dt.setMonth(dt.getMonth() + 1);
    return `${dt.getFullYear()}-${(dt.getMonth() + 1).toString().padStart(2, '0')}-${dt.getDate().toString().padStart(2, '0')} 00:00:00`;
};

/*
const formatPhone = (ph) => {
    let phone = "---";

    if (ph.indexOf("-") > 0) {
        phone = ph.replace(/\-/ig, ".");
    }
    else if (ph && ph.length >= 9) {
        phone = `${ph.slice(0, 3)}.${ph.slice(3, 6)}.${ph.slice(6, ph.length)}`;
    }

    return phone;
};
*/

const mapStateToProps = (state, ownProps) => {

    return {
        providerDetails: state.providers.providerDetails,
        providerDetailSchedule: state.openScheduling.provider,
        searchRunning: state.providers.searchRunning,
        searchSucceeded: state.providers.success,
        googleMapKey: state.session.serverData.googleMapKey,
        userLatitude: state.locations.latitude,
        userLongitude: state.locations.longitude,
        networkCode: state.session.networkCode,
        hasFirstCare: state.memberships.hasFC,
        hasHealthPlanLogin: state.memberships.hasAnySWHP,
        earliestSchedule: state.openScheduling.earliestSchedule,
        careGapsSessionId: state.careGap.careGapsSessionId,
        onlineSchedulingEnabled: state.memberships.isActiveFeature_OnlineAppointmentScheduling,
        ...ownProps
    };
};

const mapDispatchToProps = (dispatch) => {
    return {
        getProviderDetails: (searchModel) => {
            dispatch({ type: types.PROVIDER_DETAIL, searchModel: searchModel });
            //dispatch({ type: types.OPEN_SCHEDULE_PROVIDER, searchModel: { start: openScheduleStart(), end: openScheduleEnd(), providerId: searchModel.ids, providerIdType: "NPI" } });
        },
        clearProviderDetail: () => {
            dispatch({ type: types.CLEAR_PROVIDER_DETAIL });
        },
        getGeoLocation: () => dispatch({ type: types.GEOLOCATION }),
        getEarliestSchedule: (searchModel) => dispatch({ type: types.OPEN_SCHEDULE_EARLIEST, searchModel: searchModel })
    };
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(Details));
